import {useMutation, useQuery} from '@apollo/client';
import React from 'react';
import {QUERY_USER} from './graphql';
import moment from 'moment';
import Icon from '../../components/Icon';
import {MUTATION_MENTORING_RATE} from '../Mentoring/graphql';

const ClientGroups = () => {
  const {user} = useQuery(QUERY_USER).data;

  const [rate] = useMutation(MUTATION_MENTORING_RATE);

  const onRate = (mentoring, rating) => {
    if (mentoring.group.isClosed) {
      rate({variables: {input: {id: mentoring.id, rating}}});
    }
  };

  return (
    <div className="ClientGroups py-4">
      <div className="font-5 fw-bold">Модули</div>
      <div className="row g-4 pt-4">
        {user.client.mentorings.map(item => (
          <div key={item.id} className="col-3">
            <div className="bg-white rounded p-3 text-center border">
              <div className="text-muted font-2">{moment(item.group.startedAt).format('DD MMM YYYY')}</div>
              <div className="mb-2">{item.group.name}</div>
              <div className="text-muted font-2">Учитель:</div>
              <div className="font-4">{item.group.teacher.user.fullname}</div>
              <div className="row gx-1 justify-content-center mt-2">
                <div className="col-auto">
                  <button
                    onClick={() => onRate(item, 1)}
                    className={`btn p-1 ${item.rating >= 1 ? 'text-warning' : 'text-muted'}`}
                  >
                    <Icon name="star" size={22} />
                  </button>
                </div>
                <div className="col-auto">
                  <button
                    onClick={() => onRate(item, 2)}
                    className={`btn p-1 ${item.rating >= 2 ? 'text-warning' : 'text-muted'}`}
                  >
                    <Icon name="star" size={22} />
                  </button>
                </div>
                <div className="col-auto">
                  <button
                    onClick={() => onRate(item, 3)}
                    className={`btn p-1 ${item.rating >= 3 ? 'text-warning' : 'text-muted'}`}
                  >
                    <Icon name="star" size={22} />
                  </button>
                </div>
                <div className="col-auto">
                  <button
                    onClick={() => onRate(item, 4)}
                    className={`btn p-1 ${item.rating >= 4 ? 'text-warning' : 'text-muted'}`}
                  >
                    <Icon name="star" size={22} />
                  </button>
                </div>
                <div className="col-auto">
                  <button
                    onClick={() => onRate(item, 5)}
                    className={`btn p-1 ${item.rating >= 5 ? 'text-warning' : 'text-muted'}`}
                  >
                    <Icon name="star" size={22} />
                  </button>
                </div>
              </div>
              <div className="text-muted font-2">
                {!!item.rating
                  ? 'Спасибо за оценку!'
                  : item.group.isClosed
                  ? 'Оцените учителя'
                  : 'Оценка пока недоступна'}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientGroups;
